import { defineMessages } from 'react-intl';
import type { BlockSchemaProps } from '@plone/types';
import { defaultStylingSchema } from '../schema';

const messages = defineMessages({
  cardBlock: {
    id: 'Card Block',
    defaultMessage: 'Ícone e Texto',
  },
  cardLinkInternal: {
    id: 'Internal Link',
    defaultMessage: 'Link interno',
  },
  cardText: {
    id: 'Text',
    defaultMessage: 'Texto',
  },
  cardIcon: {
    id: 'Icon',
    defaultMessage: 'Ícone',
  },
  openLinkInNewPage: {
    id: 'Open in a new page',
    defaultMessage: 'Abrir em nova janela',
  },
});

export const CardSchema = (props: BlockSchemaProps): any => {
  const { intl } = props;

  const schema: any = {
    title: intl.formatMessage(messages.cardBlock),
    fieldsets: [
      {
        id: 'default',
        title: 'default',
        fields: ['text', 'icon_selector', 'href', 'openLinkInNewPage'],
      },
    ],
    properties: {
      text: {
        title: intl.formatMessage(messages.cardText),
        required: true,
      },
      icon_selector: {
        title: intl.formatMessage(messages.cardIcon),
        vocabulary: { '@id': 'ifpb.portal.vocabulary.fa-icons' },
        required: false,
      },
      href: {
        title: intl.formatMessage(messages.cardLinkInternal),
        widget: 'object_browser',
        mode: 'link',
        selectedItemAttrs: [
          'title',
          'description',
          'image_scales',
          'effective',
        ],
        allowExternals: true,
      },
      openLinkInNewPage: {
        title: intl.formatMessage(messages.openLinkInNewPage),
        type: 'boolean',
      },
    },
    required: ['text'],
  };

  // Apply default styling schema (themes, colors, etc.)
  return defaultStylingSchema({ schema, formData: props, intl });
};
